var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIcontwitter = function SvgIcontwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V1a1 1 0 00-1-1H1zm11.774 5.82c0-.11 0-.218-.007-.328.48-.36.898-.805 1.233-1.304a4.832 4.832 0 01-1.416.39c.51-.312.898-.805 1.081-1.39-.472.289-1.005.5-1.56.609A2.425 2.425 0 0010.306 3c-1.363 0-2.46 1.133-2.46 2.523 0 .196.024.391.062.579A6.934 6.934 0 012.838 3.46a2.554 2.554 0 00-.335 1.273 2.54 2.54 0 001.096 2.102 2.43 2.43 0 01-1.112-.32v.03c0 1.227.845 2.243 1.972 2.477a2.539 2.539 0 01-1.111.047 2.472 2.472 0 002.3 1.75 4.847 4.847 0 01-3.054 1.078c-.206 0-.396-.007-.594-.03A6.823 6.823 0 005.777 13c4.522 0 6.997-3.844 6.997-7.18z",
    fill: "#A7A7A7"
  })));
};
export default SvgIcontwitter;